export enum FilterMenu {
  Applied = "APPLIED",
  Saved = "SAVED",
  History = "HISTORY",
  UnhideNotes = "UNHIDENOTES",
  None = "NONE"
}
